'use client';

import { useState, FormEvent } from 'react';

const FIELD =
  'px-4 py-2.5 rounded bg-[rgba(var(--on-surface),0.1)] text-white placeholder-white/30 border border-[rgba(var(--on-surface),0.1)] focus:outline-none focus:border-[rgba(var(--on-surface),0.3)]';

export default function ForgotPasswordClient() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');

    const res = await fetch('/api/auth/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    setLoading(false);
    if (res.status === 429) {
      setError('Zu viele Versuche. Bitte in ein paar Minuten nochmal.');
      return;
    }
    // Everything else shows the same confirmation. Reporting a failure here
    // would leak through the UI exactly what the route takes care to hide.
    setSent(true);
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col gap-4 w-full max-w-sm px-6">
        <div className="text-center mb-2">
          <span className="font-bold text-white text-xl">
            kaju<span style={{ color: '#f1c953' }}>SPIELBAUSTEINE</span>
          </span>
          <p className="text-sm text-white/50 mt-1">Passwort vergessen</p>
        </div>

        {sent ? (
          <p className="text-sm text-white/70 text-center">
            Wenn es zu dieser Adresse ein Konto gibt, ist die Mail unterwegs.
            Der Link gilt 60&nbsp;Minuten.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-Mail"
              autoFocus
              required
              className={FIELD}
            />

            {error && <p className="text-sm text-red-400 text-center">{error}</p>}

            <button
              type="submit"
              disabled={loading || !email}
              className="py-2.5 rounded font-semibold transition-opacity disabled:opacity-40"
              style={{ background: '#532c29', color: '#f1c953' }}
            >
              {loading ? 'Wird gesendet…' : 'Link anfordern'}
            </button>
          </form>
        )}

        <a href="/login" className="text-sm text-white/50 text-center hover:text-white/80">
          Zurück zum Login
        </a>
      </div>
    </div>
  );
}
